/**
 * OKR 应用入口：挂载 Vue、Vant、全局 legacy 工具与路由守卫。
 * 未登录跳转 /login；首次登录强制改密跳转 /password。
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import vant from 'vant'
import 'vant/lib/index.css'
import './utils/mobileFlexible'
import './assets/reset.css'
import './assets/base.less'
import './assets/test.css'
import './assets/responsive.less'
import fastClick from 'fastclick'


import * as echarts from 'echarts'
import base from './utils/base'
import baseajax from './utils/baseajax'
import basecode from './utils/BaseCode'
import { ensureIdentityCache } from './utils/perm'


Vue.prototype.$echarts = echarts
Vue.prototype.$base = base
Vue.prototype.$basecode = basecode
Vue.prototype.$baseajax = baseajax
fastClick.attach(document.body)
fastClick.prototype.focus = function (targetElement) {
  let length;
  if (targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month') {
    length = targetElement.value.length;
    targetElement.focus();
    targetElement.setSelectionRange(length, length);
  } else {
    targetElement.focus();
  }
}

Vue.use(vant)
// 路由守卫：登录态 + 首次改密 + 权限缓存自愈
router.beforeEach(async (to, from, next) => {
  if (to.name !== 'Login' && !localStorage.getItem('UserSysno')) {
    next({
      path: '/login'
    })
    return
  }
  if (to.name !== 'Password' && localStorage.getItem('isfirst') == 1) {
    next({
      path: '/password'
    })
    return
  }
  // 权限缓存自愈：任意页面直达/刷新时补拉一次身份权限（仅冷启动一次，用户切换自动重拉），
  // 避免"缓存只在进首页 synchronize 时写入"导致非首页入口 Tab 与功能全部隐藏
  try {
    await ensureIdentityCache()
  } catch (_) {}
  next()
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js